export class Pep {
  public cod?: string;
  public description?: string;
  public descriptionEn?: string;
  public descriptionDe?: string;
  public value?: boolean;
}
